import Swal from "sweetalert2"
import withReactContent from "sweetalert2-react-content"

const Modal = withReactContent(Swal)

export default Modal
